import { type RegulatedCountry, REGULATION_CONFIG } from './getIsUserInFeesRegulatedState.constants';

export const getIsUserInFeesRegulatedState = (countryCode = '', regionCode = '') => {
    const regulatedCountry: RegulatedCountry | undefined = REGULATION_CONFIG[countryCode];
    if (!regulatedCountry) {
        return false;
    }

    const regionCodes = regulatedCountry.regions;

    if (!regionCodes) {
        return true;
    }

    return regionCodes.includes(regionCode);
};
